export const SET_SELECTED_FILTERS = 'iron/browse/SET_SELECTED_FILTERS';
export const SET_SORT = 'iron/browse/SET_SORT';
export const CLEAR_BROWSE_PRODUCTS = 'iron/browse/CLEAR_BROWSE_PRODUCTS';
export const UPDATE_SEARCH = 'iron/browse/UPDATE_SEARCH';

export const updateSearch = (searchTerm) => ({
  type: UPDATE_SEARCH,
  payload: { searchTerm },
});

export const setBrowseSort = (value) => ({
  type: SET_SORT,
  payload: { value },
});

export const setSelectedFilters = (selectedFilters) => ({
  type: SET_SELECTED_FILTERS,
  payload: { selectedFilters },
});

export const clearBrowseProducts = () => ({
  type: CLEAR_BROWSE_PRODUCTS,
});
